import React, {useContext, useState} from "react";
import {useQueryClient} from "react-query";
import {useAuth0} from "@auth0/auth0-react";
import "../../App.css";
import {makeStyles, useTheme} from "@material-ui/core/styles";
import moment from "moment/moment";

import SystemContext from "../../SystemContext";
import PageHeader from "../../blocks/PageHeader.js";
import PageFooter from "../../blocks/PageFooter";
import BookingQueueList from "./components/BookingQueueList";
import BookingQueueForm from "./components/BookingQueueForm";
import BookingQueueStyles from "./styles/BookingQueueStyles";
import {useCompaniesExternal} from "../../services/companies";
import {getCurrencyName, getRates} from "./BookingHelperFunctions";
import useCurrencies from "../../services/currencies/useCurrencies";
import useExchangeRates from "../../services/currencies/useExchangeRatesWithName";
import {useSettings} from "../../services/settings";
import {useHistory} from "react-router-dom";
import {getDefaultValuesWithoutAlert} from "../../functions/TemplateHelperFunctions";


const AccessControl = require ("../../AccessControl");

function CustomerBookingQueue(props) {
  const SystemData = useContext(SystemContext);
  const classes = makeStyles(BookingQueueStyles)();

  const { isAuthenticated, user } = useAuth0();
  const canEdit = AccessControl.userHasAccess(user, ["Super Admin", "Admin", "Manage BOOKINGS", "Client ADMIN", "Client ACCESS"]);
  const userInfo = AccessControl.getUserInfo();
  const userClass = userInfo?.userClass;

  const queryClient = useQueryClient();
  const extraKeys = ["SYSTEM", moment().format("YYYY-MM-DD")];
  const currencies = useCurrencies({queryClient, extraKeys: []});
  const exchangeRates = useExchangeRates({queryClient, extraKeys});
  const terms = useSettings({queryClient, extraKeys: ["TERMS"]});
  const companyData = useCompaniesExternal({queryClient, extraKeys: [userInfo.companyUuid]});
  const companyRecord = {};

  if (userClass ==="GSA" &&
    companyData && companyData.data && exchangeRates && exchangeRates.data && Array.isArray(exchangeRates.data)) {

    const company = companyData.data;
    companyRecord["gsaCompanyUuid"] = userInfo.companyUuid;
    companyRecord["gsaCompanyName"] = company.companyName;
    companyRecord["gsaCurrencyRates"] = getRates(company.defaultCurrencyCode, exchangeRates.data);
    companyRecord["gsaDefaultCurrencyCode"] = company.defaultCurrencyCode;
    companyRecord["gsaDefaultCurrencyName"] = getCurrencyName(company.defaultCurrencyCode, currencies.data);
  }


  const [state, setState] = useState({
    selectedRecord: null
  });
  const [defaults, setDefaults] = useState(null);
  const history = useHistory();
  const handleClose = event => {
    SystemData.goHome(history);
  };

  const getDefaults = async () => {
    const defaults = await getDefaultValuesWithoutAlert(SystemData, "booking", "defaults");
    if (!defaults)
      return null;
    return defaults;
  }

  getDefaults()
    .then((bookingDefaults) => {
      if (!defaults)
        setDefaults(bookingDefaults);
    })
    .catch((error) => {
      handleClose();
      SystemData.alert("Error", error);
    });

  let theme = useTheme();
  const values = {
    xs: 0,
    sm: 600,
    lsm: 720,
    md: 960,
    mlg: 1120,
    lg: 1280,
    lgr: 1750,
    xl: 1920,
    xxl: 2400
  };

  theme.breakpoints = {...theme.breakpoints,
    keys: ['xs', 'sm', 'lsm', 'md', 'mlg', 'lg', 'lgr', 'xl', 'xxl'],
    up: key => `@media (min-width:${values[key]}px)`,
  };

  const changeSelectedRecord = (selectedRecord) => {
    // setState({...state, selectedRecord});
  }

  return (isAuthenticated &&
    <div
      className="CustomerBookingQueue"
      style={{
        backgroundColor: "#eeeeee",
        color: "#1b4481",
        fontWeight: 400,
        fontFamily: "Ubuntu,sans-serif",
        minHeight: "100vh",
      }}
    >
      <PageHeader
        parentProps={props}
        activeMenuItem="customerbookingqueue"
        pageName="New & Changed Bookings"
        loggedInUser={user}
        logout={""}
      ></PageHeader>
      <div
        style={{
          marginLeft: 40,
          marginRight: 40,
          height: 2,
          backgroundColor: "#b7c3d4",
        }}
      ></div>
      <div style={{ height: 10 }}></div>
      <div
        className={classes.rooted}
        style={{ marginLeft: 20, marginRight: 20, minHeight: `calc(100vh - ${(99+2+10+57+4+4)}px)`, height: `calc(100vh - ${(99+2+10+57+4+4)}px)` }}
      >
        <div style={{display: "flex", width: "100%", position: "relative"}}>
          <div style={{display: "inline-flex", position: "relative", width: `calc(100vw - 495px)`, maxWidth: `calc(100vw - 495px)`}}>{/* minWidth: listWidth, */}
            <BookingQueueList customerBookings={companyRecord} canEdit={canEdit} classes={classes} theme={theme} height={99+2+10+57+4+4} defaults={defaults}/>
          </div>
          <div style={{display: "inline-flex", width: 400, MinWidth: 400, maxWidth: 400, marginLeft:20, backgroundColor: "#ffffff"}}>
            <BookingQueueForm canEdit={false} customerBooking={true} classes={classes} height={99+2+10+57+4+4}/>
          </div>
        </div>
      </div>

      <PageFooter></PageFooter>
    </div>
  );
}

export default CustomerBookingQueue;
